import '../../../scss/pages/responsible-disclosure/main.scss';
import onDomContentLoaded from '../../utilities/onDomContentLoaded';
import { RESPONSIBLE_DISCLOSURE_ENTRY_ID } from '../../api/content-service-api';
import contentfulStartup from '../../utilities/contentful/contentfulStartup';

onDomContentLoaded(() =>
    contentfulStartup({ containerId: 'responsible-disclosure--container', entryId: RESPONSIBLE_DISCLOSURE_ENTRY_ID })
);
